import React from 'react'
import styles from './Header.module.css'
import { Link } from 'react-router-dom'

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={`${styles.topo} container`}>
        <Link className={styles.logo} to="/" aria-label="Cupons">
            <img src="https://cdn1.staticpanvel.com.br/cdn_service/svg/account-images/coupon-icon-logo.svg" alt="logo" className={styles.logoImg}/>
        </Link>
      </div>
    </header>
  )
}

export default Header
